import React from 'react';
import { Button } from 'reactstrap';
import { Link } from 'gatsby';

const Brand = ({ url, name }) => (
  <a href={(url) ? `//${url}` : ''}>{(name) ? `${name}` : ''}</a>
);

export class ProductCardsComponent extends React.Component {
  render() {
    const {
      products, large, medium, hideBrand,
    } = this.props;

    return (
      <>
        <div className="row product-main">
          {products && products.map((product) => {
            const displayedOption = product.declinaisons ? product.declinaisons[0] : product;
            const unitPrice = product.conditionnement
              ? (displayedOption.price / product.conditionnement)
              : displayedOption.price;
            return (
              <div
                className={`Catalogue__item col-sm-12 col-md-${medium ?? 6} col-lg-${large ?? 4}`}
                key={product.id}
              >
                <Link
                  to={`${product.categories[0].slug}/${product.categories[1].slug}/${product.slug}`}
                >
                  <div className="details_List">
                    <img alt={`${product.name}`} src={product.image.file.url} />

                    <div className="details_inner">
                      <h2>
                        <Link
                          to={`${product.categories[0].slug}/${product.categories[1].slug}/${product.slug}`}
                        >
                          {product.name}
                        </Link>
                      </h2>
                      {
                        (!hideBrand && product.brand && product.brand.website)
                          ? (
                            <Brand
                              url={product.brand.website}
                              name={product.brand.companyName.companyName}
                            />
                          )
                          : <p />
                      }

                      <div>
                        {`${unitPrice.toFixed(2)} € HT`}
                      </div>
                      <div>
                        {`(${(unitPrice * 1.2).toFixed(2)} € TTC)`}
                      </div>
                      <p />

                      <div className="row">
                        <div className="col-sm-12 text-left calign-self-center">
                          <Link
                            to={`${product.categories[0].slug}/${product.categories[1].slug}/${product.slug}`}
                          >
                            <Button className="rentProduct">
                              Louer ce produit
                            </Button>
                          </Link>
                        </div>
                      </div>
                      {/*
                  <StarRatingComponent
                    editing={false}
                    name={product.slug}
                    starCount={5}
                    value={product.rating}
                  />
                  {
                    displayDescription
                      ? <p>{product.details.childMarkdownRemark.excerpt}</p>
                      : <></>
                  }
                  */}

                      {/*
                  <div className="row">
                    <div
                      className={`col-sm-${hideBuyLabel ? 8 : 4} text-left calign-self-center`}
                      style={{ paddingRight: 0 }}
                    >
                      <span className="price">
                        {product.declinaisons ? (
                          product.declinaisons[0].price
                            ? `${product.declinaisons && product.declinaisons[0].price} €`
                            : 'Prix non renseigné'
                        ) : (
                          `${product.price} €`
                        )}
                      </span>
                    </div>
                    <div className={`col-sm-${hideBuyLabel ? 4 : 8} text-left calign-self-center`}>
                      {
                        (product)
                          ? (
                            <SnipcartButton
                              product={product}
                              selectedOption={0}
                              tiny
                              hideBuyLabel={hideBuyLabel}
                            />
                          )
                          : ''
                      }
                    </div>
                  </div>
                  */}
                    </div>
                  </div>
                </Link>
              </div>
            );
          })}
        </div>
      </>
    );
  }
}
